import script from "./depositView.vue?vue&type=script&setup=true&lang=ts"
export * from "./depositView.vue?vue&type=script&setup=true&lang=ts"

import "./depositView.vue?vue&type=style&index=0&id=df0f8048&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df0f8048"]])

export default __exports__